if (!customElements.get('announcement-bar-premium')) {
  class AnnouncementBarPremium extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-abp-track]');
      this.items = Array.from(this.querySelectorAll('[data-abp-item]'));
      this.prevBtn = this.querySelector('[data-abp-prev]');
      this.nextBtn = this.querySelector('[data-abp-next]');
      this.indicators = Array.from(this.querySelectorAll('[data-abp-indicator]'));
      this.currentIndex = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.swipe = this.dataset.swipe !== 'false';
    }

    connectedCallback() {
      if (!this.track || this.items.length < 2) return;

      if (!this.swipe) {
        this.classList.add('announcement-bar-premium--no-swipe');
      }

      this.prevBtn?.addEventListener('click', () => this.go(this.currentIndex - 1, true));
      this.nextBtn?.addEventListener('click', () => this.go(this.currentIndex + 1, true));

      this.indicators.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10), true));
      });

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }

      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      window.addEventListener('resize', () => this.updateActive(), { passive: true });

      this.updateActive();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(index, userInitiated) {
      const count = this.items.length;
      const next = (index + count) % count;
      const left = next * this.track.clientWidth;
      this.track.scrollTo({ left, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      this.currentIndex = next;
      this.setActive(next);
      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    onScroll() {
      window.clearTimeout(this._scrollTimeout);
      this._scrollTimeout = window.setTimeout(() => this.updateActive(), 80);
    }

    updateActive() {
      if (!this.track.clientWidth) return;
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.currentIndex = index;
      this.setActive(index);
    }

    setActive(index) {
      this.indicators.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    start() {
      if (!this.autoplay || this.items.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.go(this.currentIndex + 1, false), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('announcement-bar-premium', AnnouncementBarPremium);
}
